@if (!isAuthRoute()) { <app-header></app-header> }
  <router-outlet></router-outlet>
@if (!isAuthRoute()) { <app-footer></app-footer> }
<app-cookie-consent></app-cookie-consent>
<app-login-required-modal></app-login-required-modal>
